<script>
import InfoIcon from '@/views/hotel-management/reservations/detail/icons/InfoIcon.vue'

export default {
  name: 'HMInfo',
  props: {
    rData: { type: Object, required: true },
  },
  components: { InfoIcon }
}
</script>

<template>
  <div class="hm-info">
    <div class="hm-info__title">
      <InfoIcon/>
      <span>{{ rData.notes }}</span>
    </div>
  </div>
</template>

<style scoped>
.hm-info {
  margin-bottom: 60px;
  color: #505050;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 13px;
  line-height: 19px;
}

.hm-info__title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
</style>